import { useNotificationObserver } from "../hooks/use-notification-observer";
import { usePushRegistration } from "../hooks/use-push-registration";

/**
 * Null-rendering mount point for push registration and notification
 * deep-linking. Rendered inside the authenticated navigator once the profile
 * is complete, so the OS permission prompt never fires over the
 * complete-profile screen and notification taps never navigate into
 * protected routes before the auth guards allow it.
 */
export function PushRegistrar() {
  usePushRegistration();
  useNotificationObserver();
  return null;
}
